import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux';
import { setIndex } from '../state/menuHighlight';
import { logoutSuccess } from '../state/authRedux';
import { useNavigate } from 'react-router-dom';
import { FcStatistics } from "react-icons/fc";
import { Canvas } from '@react-three/fiber'
import {Scene} from './Scene';
import Loader from '../Modals/Loader';
import api from '../API/api';
import { GrConfigure } from "react-icons/gr";
import { GoGear } from "react-icons/go";
import { LuBrainCircuit } from "react-icons/lu";
import { PiBrainThin } from "react-icons/pi";
import { IoBookOutline } from "react-icons/io5";
import { BsChat } from "react-icons/bs";
import { IoCubeOutline } from "react-icons/io5";
import { PiSquaresFour } from "react-icons/pi";
import { FaWandMagicSparkles } from "react-icons/fa6";
import { LuHistory } from "react-icons/lu";
import { RiSketching } from "react-icons/ri";

/*upload button imports*/
import { styled } from '@mui/material/styles';
import Button from '@mui/material/Button';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';

/*Generate Button*/
import Stack from '@mui/material/Stack';

/*modal imports*/
import { Dialog, Transition, TransitionChild, DialogPanel, DialogTitle } from '@headlessui/react'
import { ThreeDots} from 'react-loader-spinner';


export const SketchTo3D = () => {
    
    const [menu,setMenu] = useState(0);
    const highlightIndex = useSelector((state)=>state.highlight.index)
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const user = useSelector((state)=>state.user.currentUser)
    const [genImage,setGenImage] = useState();
    const [modelData,setModelData] = useState();
    const [modelUrl,setModelUrl] = useState();
    const loaderRef = useRef()
    const [isOpen,setIsOpen] = useState(false)

    const numberOfStars = 100;

  // Create an array of stars with randomized properties
    const stars = Array.from({ length: numberOfStars }, () => ({
        size: Math.random() * 2 + 1, // Random size between 1px and 4px
        left: Math.random() * 100 + '%', // Random horizontal position
        top: Math.random() * 100 + '%', // Random vertical position
        delay: Math.random() * 5 + 's', // Random animation delay between 0s and 5s
        duration: Math.random() * 5 + 3 + 's', // Random animation duration between 3s and 8s
    }));

    const logOut = () => {
        dispatch(logoutSuccess())
        navigate('/login')
        console.log('logout now')
    }

    const LinkOnClick = (index) => {
        console.log('link clicked')
    }
    const GenerateOnClick = async () => {
        setModelData(null)
        loaderRef.current.toggleState()
        if(!genImage){
            loaderRef.current.toggleState()
            return
        }
        const fd = new FormData()

        fd.append('file',genImage)
        const response = await api.post(`/add3DModelImage`,fd,{headers:{'Content-Type': 'multipart/form-data'}})
        console.log(response)
        const binaryBuffer = new Uint8Array(response.data.split('').map((char) => char.charCodeAt(0)));

        // Create a Blob from the binary buffer
        const blob = new Blob([binaryBuffer], { type: 'model/gltf-binary' });

        // Generate a Blob URL
        const url = URL.createObjectURL(blob);
        console.log(url)
        setModelUrl(url)
        console.log(modelUrl)
        console.log('model url logged')
        //setModelData(response.blob())

        loaderRef.current.toggleState()

    }
    
    function open() {
        setIsOpen(true)
    }
    
    

    const VisuallyHiddenInput = styled('input')({
        clip: 'rect(0 0 0 0)',
        clipPath: 'inset(50%)',
        height: 1,
        overflow: 'hidden',
        position: 'absolute',
        bottom: 0,
        left: 0,
        whiteSpace: 'nowrap',
        width: 1,
      });

    

    useEffect(()=>{
    })

useEffect(()=>{
    dispatch(setIndex({index:5}))
    console.log(highlightIndex)
},[])
return (
    <div className=' w-[100%] h-[100%] flex  items-center duration-300 ease-in-out'>
        {
        <div className='w-[100%] md:w-[75%] h-[100%]'>
            {/* Top Bar Studio area */
            <div className='flex h-[8%] bg-[#18181b] border-b border-gray-700 w-[100%]  p-2 shadow-2xl items-center justify-center'>
                <div className='w-[100%] h-[100%] pl-4 flex font-sans text-[14px] font-normal leading-[20px] text-gray-400'> 
                    <div className='w-[20%] h-[100%] text-center flex items-center'>
                        <span>Sketch To 3D</span>
                    </div>
                    <div className='w-[80%] h-[100%] flex items-center justify-evenly'>
                        <span className='flex items-center'>
                            <IoBookOutline/>
                            <span className='ml-2'>Docs</span>
                        </span>
                        <span className='flex items-center'>
                            <BsChat/>
                            <span className='ml-2'>Discord</span>
                        </span>
                        <span className='flex items-center'>
                            <PiSquaresFour/>
                            <span className='ml-2'>2D Library</span>
                        </span>
                        <span className='flex items-center'>
                            <IoCubeOutline/>
                            <span className='ml-2'>3D Library</span>
                        </span>
                        <span className='flex items-center'>
                            <FaWandMagicSparkles/>
                            <span className='ml-2'>Quick Tips</span>
                        </span>
                        <span className='flex items-center'>
                            <LuHistory/>
                            <span className='ml-2'>Changelog</span>
                        </span>
                    </div>
                    </div>              
            </div>}
            {   <>
                    <div className='h-[72%] md:h-[92%] w-[100%] bg-[#18181b] flex flex-col items-center justify-between'>
                        
                        {
                            <Canvas camera={{ position: [15, 10, 15], fov: 75 }}>
                                <Scene modelData={modelData} modelType='glb' modelURL={modelUrl}></Scene>
                            </Canvas>}
                    </div>
                    <div className='h-[20%] md:hidden w-[100%] flex flex-col items-center justify-evenly bg-gray-300'>
                        {/*upload file button*/}
                        {<Button
                        component="label"
                        role={undefined}
                        variant="contained"
                        tabIndex={-1}
                        startIcon={<CloudUploadIcon />}
                        title='Upload File'
                        >
                        Upload files
                        <VisuallyHiddenInput
                            type="file"
                            onChange={(event) => setGenImage(event.target.files[0])}
                        />
                        
                        </Button>}
                        
                        <Stack spacing={2} direction="row">
                        <Button variant="contained" onClick={()=> GenerateOnClick()}>Generate 3D Model</Button>
                        </Stack>
                                                </div>
                </>

            }
            <Loader ref={loaderRef}/>
        </div>
        }
        {
        <div className={`hidden md:block fixed border-l border-gray-700 z-50 md:relative top-0 w-[50%] xs:h-screen  md:z-0 xs:w-[10%]  bg-[#18181b] md:h-screen  md:pt-0 md:w-[25%] duration-300 relative`}>
                        {/*upload file button*/}
                        {
                        <div className='w-[100%] h-[8%] border-b border-gray-700'>
                            <div class="w-[100%] h-[100%] flex justify-between items-center p-4 ">
                                <span class="text-gray-300 font-medium">Filters</span>
                                <button class="p-2 rounded-lg bg-white bg-opacity-10 text-gray-300 hover:bg-opacity-20 transition-all" title="Collapse sidebar">
                                    <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                                        <polyline points="9 18 15 12 9 6"></polyline>
                                    </svg>
                                </button>
                            </div>
                        </div>
                        }
                    <div className='p-5 w-[100%] h-[92%] md:p-5 '>
                        { <div className='font-sans text-[14px] font-normal leading-[20px]'>
                            <input type="search" placeholder="Search Prompt or Tag" class="w-full h-10 pl-10 pr-4 text-sm text-gray-200 placeholder-gray-400 bg-white bg-opacity-10 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500" value="">

                            </input>
                            <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" class="absolute top-1/2 left-3 transform -translate-y-1/2 text-gray-400" height="16" width="16" xmlns="http://www.w3.org/2000/svg"><circle cx="11" cy="11" r="8"></circle><line x1="21" y1="21" x2="16.65" y2="16.65"></line></svg>
                        </div>
                        }
                        {
                            <h3 class="text-sm font-medium text-gray-300 flex items-center">
                                <svg stroke="currentColor" fill="currentColor" stroke-width="0" viewBox="0 0 24 24" class="mr-2" height="18" width="18" xmlns="http://www.w3.org/2000/svg">
                                    <path fill="none" d="M0 0h24v24H0V0z"></path>
                                    <path d="M7 11h2v2H7v-2zm14-5v14c0 1.1-.9 2-2 2H5a2 2 0 0 1-2-2l.01-14c0-1.1.88-2 1.99-2h1V2h2v2h8V2h2v2h1c1.1 0 2 .9 2 2zM5 8h14V6H5v2zm14 12V10H5v10h14zm-4-7h2v-2h-2v2zm-4 0h2v-2h-2v2z"></path>
                                </svg>
                                Date Filter
                            </h3>
                        }
                        {
                            //drop zone upload
                            <>
                                <div role="presentation" tabindex="0" class="dropzone relative bg-[#030527] bg-opacity-60 border-zinc-600 border-opacity-50 transition-all duration-300 ease-in-out rounded-md cursor-pointer px-3 py-3 border-dashed border w-full mt-4">
                                    <input className='' onChange={(event) => setGenImage(event.target.files[0])} accept=".jpg, .jpeg, .png" type="file"  tabindex="-1"/>
                                    <div class="flex flex-col items-center py-3 mb-1">
                                        <svg stroke="currentColor" fill="none" stroke-width="2" viewBox="0 0 24 24" stroke-linecap="round" stroke-linejoin="round" class="mb-1 text-zinc-300" height="20" width="20" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path>
                                            <polyline points="17 8 12 3 7 8"></polyline>
                                            <line x1="12" y1="3" x2="12" y2="15"></line>
                                        </svg>
                                        <div class="text-center">
                                            <p class="font-sans text-[14px] font-normal leading-[20px] text-gray-400 mb-2 mt-2">Upload Sketch</p>
                                            <p class="font-sans text-[14px] font-normal leading-[20px] text-gray-400 mb-6">JPG and PNG formats, up to 5MB</p>
                                            <button class="px-3 py-1 bg-zinc-700 border-zinc-600 border text-zinc-300 rounded-md text-xs font-semibold hover:bg-zinc-600 transition-colors duration-300">Browse File</button>
                                        </div>
                                    </div>
                                </div>
                                <div className='flex items-center justify-center'>
                                    <p class="font-sans text-[14px] font-normal leading-[20px] text-gray-400 mb-2 mt-2">or</p>
                                </div>
                                <div className='mt-5 w-[100%] self-center text-white flex'>
                                    <Stack className='w-[100%]' spacing={2} direction="row">
                                    <Button  style={{ textTransform: 'none' }} className='w-[100%] font-sans text-[14px] font-normal leading-[20px] text-gray-400' variant="contained" onClick={()=> setIsOpen(!isOpen)}>
                                        <RiSketching className='text-white mr-2'/><span>Sketch</span>
                                    </Button>
                                    </Stack>
                                </div>
                            </>
                        }
                        <div className='mt-5 w-[100%] self-center text-white flex border-b border-gray-500 pb-2'>
                            <div className='w-[50%] flex items-center  font-sans text-[14px] font-normal leading-[20px] text-gray-400 '>
                                <GoGear className='text-white mr-2'/><span>Configuration</span>
                            </div>
                        </div>
                        <div className='mt-5 w-[100%] self-center text-white flex flex-col'>
                            <div className=' mb-2 w-[50%] flex items-center  font-sans text-[14px] font-normal leading-[20px] text-gray-400 '>
                                <PiBrainThin className='text-white mr-2'/><span>Generative Model</span>
                            </div>
                            <select id="modelSelector" className="font-sans text-[14px] font-normal leading-[20px] text-gray-400 w-full appearance-none bg-zinc-800 bg-opacity-90 border border-gray-600 border-opacity-50 text-gray-300 text-sm py-2 pr-8 rounded-sm leading-tight focus:outline-none focus:bg-zinc-700 focus:border-gray-500"><option className="bg-zinc-800 text-sm" value="tripo-v1">Swift (V1 Preview)</option><option className="bg-zinc-800 text-sm" value="deemos">Forge (V1 Regular)</option><option class="bg-zinc-800 text-sm" value="tripo-v2">Prism (V1 Sketch)</option><option class="bg-zinc-800 text-sm" value="tripo-v2-multi">Prism Multi-View (V1 Sketch)</option></select> 
                        </div>
                        <div className='mt-5 w-[100%] self-center text-white flex'>
                            <Stack className='w-[100%]' spacing={2} direction="row">
                            <Button  style={{ textTransform: 'none' }} className='w-[100%] font-sans text-[14px] font-normal leading-[20px] text-gray-400' variant="contained" onClick={()=> setIsOpen(!isOpen)}>
                                <GoGear className='text-white mr-2'/><span>Advanced Configuration</span>
                            </Button>
                            </Stack>
                        </div>
                        <div className='mt-5 w-[100%] self-center text-white flex'>
                            <Stack className='w-[100%]' spacing={2} direction="row">
                            <Button style={{ textTransform: 'none' }} className='w-[100%] font-sans text-[14px] font-normal leading-[20px] text-gray-400' variant="contained" onClick={()=> GenerateOnClick()}>Generate 3D Model</Button>
                            </Stack>
                        </div>
                        
                        </div>
                    </div>
        } 
        {
            <>
                <Transition appear show={isOpen}>
                            <Dialog as="div" className="relative z-10 focus:outline-none" onClose={open}>
                            <div className="fixed inset-0 " aria-hidden="true" />
                            <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
                                <div className="flex min-h-full items-center justify-center p-4">
                                <TransitionChild
                                    enter="ease-out duration-300"
                                    enterFrom="opacity-0 transform-[scale(95%)]"
                                    enterTo="opacity-100 transform-[scale(100%)]"
                                    leave="ease-in duration-200"
                                    leaveFrom="opacity-100 transform-[scale(100%)]"
                                    leaveTo="opacity-0 transform-[scale(95%)]"
                                    
                                >
                                    <DialogPanel className="w-[700px] h-[500px]">
                                        <DialogTitle as="h3" className="text-base/7 font-medium text-gray-600 bg-[#030527] flex items-center justify-center">
                                            
                                            <div className='flex items-center'>
                                                <GoGear className='text-white mr-2'/><span className={`font-sans text-[14px] font-normal w-[100%] h-[100%]
                                                leading-[20px]
                                                text-gray-400  
                                                bg-[#030527]`}>Advanced Configuration</span>
                                            </div>
                                        </DialogTitle>
                                        <div className={`font-sans text-[14px] font-normal w-[100%] h-[100%]
                                            leading-[20px]
                                            text-gray-400 flex items-center justify-center 
                                            bg-[#030527]`}>
                                            

                                            <div className='mt-5 w-[30%] self-center text-white flex'>
                                                <Stack className='w-[100%]' spacing={2} direction="row">
                                                <Button style={{ textTransform: 'none' }} className='w-[100%] font-sans text-[14px] font-normal leading-[20px] text-gray-400' variant="contained" onClick={()=> setIsOpen(false)}>Close</Button>
                                                </Stack>
                                            </div> 
                                        </div>
                                    </DialogPanel>
                                </TransitionChild>
                                </div>
                            </div>
                            </Dialog>
                        </Transition>
                    </>
        }
    </div>
)
}